import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const AppFooter = () => {
  return (
    <footer className="appFooter">
      <div className="appFooter__inner">
        <div className="appFooter__cols">
          <div className="appFooter__col">
            <div className="appFooter__title">Informace</div>
            <a
              className="appFooter__link"
              href="https://msp.gov.cz/web/msp/ministerstvo-spravedlnosti1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Kontakty pro média
            </a>
            <a
              className="appFooter__link"
              href="https://msp.gov.cz/prohlaseni-o-pristupnosti"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prohlášení o přístupnosti
            </a>
            <a
              className="appFooter__link"
              href="https://msp.gov.cz/zasady-ochrany-osobnich-udaju"
              target="_blank"
              rel="noopener noreferrer"
            >
              Zpracování kontaktních údajů a cookies
            </a>
          </div>

          <div className="appFooter__col">
            <div className="appFooter__title">Máte dotaz? Napište nám</div>
            <a
              className="appFooter__link"
              href="https://msp.gov.cz/web/msp/podatelna-ministerstva"
              target="_blank"
              rel="noopener noreferrer"
            >
              Podatelna ministerstva
            </a>
          </div>

          <div className="appFooter__col">
            <div className="appFooter__title">Sociální sítě</div>
            <div className="appFooter__social">
              <a
                className="appFooter__socialLink"
                href="https://www.facebook.com/ministerstvospravedlnosti"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FacebookIcon sx={{ fontSize: 28 }} />
              </a>
              <a
                className="appFooter__socialLink"
                href="https://twitter.com/SpravedlnostCZ"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <TwitterIcon sx={{ fontSize: 28 }} />
              </a>
              <a
                className="appFooter__socialLink"
                href="https://www.instagram.com/ministerstvospravedlnosti"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon sx={{ fontSize: 28 }} />
              </a>
              <a
                className="appFooter__socialLink"
                href="https://cz.linkedin.com/company/ministerstvo-spravedlnosti-%C4%8Desk%C3%A9-republiky"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <LinkedInIcon sx={{ fontSize: 28 }} />
              </a>
            </div>
          </div>
        </div>

        <div className="appFooter__bottom">
          <div className="appFooter__copyright">
            Ministerstvo spravedlnosti České republiky
          </div>

          <div className="appFooter__logos">
            <img
              src="https://msp.gov.cz/o/justicecz-js-theme/images/npo.svg"
              alt="Logo Národní Plán Obnovy"
              className="appFooter__logoImg"
              width="114"
              height="31"
            />
            <img
              src="https://msp.gov.cz/o/justicecz-js-theme/images/eu-podpora.svg"
              alt="Logo NextGeneration EU"
              className="appFooter__logoImg"
              width="114"
              height="31"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
